export default "__VITE_ASSET__BPIrxdAL__"